export default "__VITE_ASSET__DJAYAJ2f__"